import React from "react";

import "../../scss/organisms/_form.scss";

class FormApply extends React.Component {
  state = {
    uploadLabelValue: "Upload a file...",
  };
  fileInputChange = (e) => {
    let control = e.currentTarget;

    var fileName = "";
    if (control.files && control.files.length > 1) {
      fileName = (control.getAttribute("data-multiple-caption") || "").replace(
        "{count}",
        control.files.length
      );
    } else {
      fileName = e.target.value.split("\\").pop();
    }

    if (fileName) {
      this.setState({ uploadLabelValue: fileName });

      //this.props.handleFilesSelection(control.files[0]);
    } else {
      this.setState({ uploadLabelValue: "Upload a file..." });

      //this.props.handleFilesSelection(undefined);
    }
  };
  render() {
    const formContent = (
      <>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="first-name">My first name is</label>
              <input
                type="text"
                className="form-control"
                name="first-name"
                onChange={(e) => this.props.handleChange(e)}
                required="required"
              />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="last-name">My last name is</label>
              <input
                type="text"
                className="form-control"
                name="last-name"
                onChange={(e) => this.props.handleChange(e)}
                required="required"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="phone">My phone number is</label>
              <input
                type="text"
                className="form-control"
                name="phone"
                onChange={(e) => this.props.handleChange(e)}
                required="required"
              />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="email">My e-mail address is</label>
              <input
                type="text"
                className="form-control"
                name="email"
                onChange={(e) => this.props.handleChange(e)}
                required="required"
              />
            </div>
          </div>
        </div>

        {/* <div className="row">
          <div className="col-sm-6">
            <div className="form-group form-upload">
              <label>I'm uploading my CV:</label>
              <input
                type="file"
                id="cv"
                name="file-attachment"
                onChange={e => {
                  this.fileInputChange(e);
                  this.props.handleFilesSelection(e);
                }}
                accept=".doc,.docx,.pdf,.xls,.xlsx"
              />
              <label htmlFor="cv" className="form-control">
                {this.state.uploadLabelValue}
              </label>
            </div>
          </div>
        </div> */}

        <div className="form-group">
          <label htmlFor="message">I just wanted to say this:</label>
          <textarea
            className="form-control"
            name="message"
            onChange={(e) => this.props.handleChange(e)}
            required="required"
          />
        </div>
        <div className="d-flex mt-6">
          <button className="ml-auto mr-auto btn btn-secondary">
            <span>Submit</span>
          </button>
        </div>
        <div className="form-footer pt-5">
          <div className="row">
            <div className="col-md-6">
              <p>
                We will only use the information to handle your enquiry. We will
                not share your information with any third parties.
              </p>
            </div>
          </div>
        </div>
      </>
    );

    const successMessage = <p>Your message was successfully received.</p>;
    const errorMessage = (
      <p>There was an error while processing your request. Please try again.</p>
    );

    return (
      <section
        className={
          "form form-apply" +
          (this.props.className ? " " + this.props.className : "")
        }
      >
        <div className="container">
          <form
            name="apply"
            method="post"
            data-netlify="true"
            onSubmit={(e) => this.props.submitForm(e)}
          >
            {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
            <input type="hidden" name="form-name" value="apply" />
            <input type="hidden" name="path" value={this.props.path} />
            <h2 className="form-title">{this.props.title}</h2>
            {this.props.children}
            {this.props.formState === undefined
              ? formContent
              : this.props.formState === "success"
              ? successMessage
              : errorMessage}
          </form>
        </div>
      </section>
    );
  }
}

export default FormApply;
